<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Detalle de Artículo&nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-5
            .field
              label.label Tipo
              .control
                typeahead#type_itemsTipo(:options="tipos" :optionSelect="itemData" v-model="itemSel")
          .column.is-2(v-show="isTipoTel")
            .field
              label.label Telefono
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='55555555',
                  v-model="articulo.numeroTelefono",
                  :disabled="isDisabled"
                )
          .column.is-2(v-show="isTipoVehiculo")
            .field
              label.label Placas
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='XYZ-123456',
                  v-model="articulo.placas",
                  :disabled="isDisabledVehiculo"
            )
          .column.is-2
            .field
              label.label # Serie
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='# Serie',
                  v-model="articulo.serie",
                  :disabled="isDisabled"
                )
          .columns.is-vcentered(v-show="isTipoVehiculo")
            .column
              a.button.is-warning.is-rounded.is-small(v-show="!isEditingPlacas" @click="editarPlacas")
                | Editar
              | &nbsp
              a.button.is.is-rounded.is-small(v-show="isEditingPlacas" @click="cancelarEditarPlacas")
                | Cancelar
              | &nbsp
              a.button.is.is-rounded.is-primary.is-small(v-show="isEditingPlacas" @click="actualizarPlacas")
                | Actualizar
          .column.is-6(v-show="isTipoTarjeta")
            .field
              label.label Automóvil
              .control.has-icons-left
                .select.is-black.is-rounded
                  select(v-model="automovilSel" :disabled="isDisabledTarjeta")
                    option(v-for="a in automoviles" :value="a") {{ `${a.categoria} ${a.marca} ${a.modelo} ${a.placas}` }}
                .icon.is-small.is-left
                  i.fas.fa-car
          .column(v-show="isTipoTarjeta")
            a.button.is-warning.is-rounded.is-small(v-show="!isEditingAuto" @click="editarAuto")
              | Editar
            | &nbsp
            a.button.is.is-rounded.is-small(v-show="isEditingAuto" @click="cancelarEditarAuto")
              | Cancelar
            | &nbsp
            a.button.is.is-rounded.is-primary.is-small(v-show="isEditingAuto" @click="actualizarAuto")
              | Actualizar
        .columns
          .column.is-2
            .field
              label.label Marca
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='Marca',
                  v-model="articulo.marca",
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              label.label Modelo
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='Modelo',
                  v-model="articulo.modelo",
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              label.label Tag
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='Tag',
                  v-model="articulo.tag",
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              label.label # Parte
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Serie',
                  v-model="articulo.noParte"
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              label.label # Partida
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Serie',
                  v-model="articulo.partida"
                  :disabled="isDisabled"
                )
        .columns
          .column.is-2
            .field
              label.label Dirección IP
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='127.0.0.1',
                  v-model="articulo.direccionIP",
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              label.label MAC Address W.
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='D3:D9:01:C3:3E:AF',
                  v-model="articulo.macAddressW",
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              label.label MAC Address E.
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='D3:D9:01:C3:3E:AF',
                  v-model="articulo.macAddressE",
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              label.label Ubicación del Artículo
              .control.has-icons-left
                .select.is-black.is-rounded
                  select(v-model="articulo.ubicacion" :disabled="isDisabledEspecial")
                    option(value="") Selecciona la Ubicación
                    option(value="CORP") Corporativo
                    option(value="IRGE") IRGE
                    option(value="TPA") TPA
                    option(value="IRGE") IRGE
                    option(value="LPGD") DUCTO
                    option(value="EB00") EB00
                    option(value="EB01") EB01
                    option(value="EB02") EB02
                    option(value="EB03") EB03
                    option(value="EB04") EB04
                    option(value="ERM") ERM
                .icon.is-small.is-left
                  i.fas.fa-map-pin
          .column.is-2
            .field
              label.label Oficina
              .control.has-icons-left
                .select.is-black.is-rounded
                  select(v-model="articulo.oficina" :disabled="isDisabledEspecial")
                    option(v-for="ofi in oficinas" :value="ofi.clave") {{ ofi.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-map-pin
          .column.is-2
            .field
              label.label Localización
              .control.has-icons-left
                .select.is-dark.is-rounded
                  select(v-model="articulo.localizacion" :disabled="isDisabled")
                    option(v-for="l in localizacionesFilter" :key="l.id" :value="l.id") {{ l.localizacion }}
        .columns.is-vcentered
          .column.is-3
            .field
              label.label Orden de Compra
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='Orden de Compra',
                  v-model="articulo.ordenCompra",
                  :disabled="isDisabled"
                )
          .column.is-3
            .field
              label.label Fecha de Compra:
              .control
                flat-pickr(
                  v-model='articulo.fechaCompra'
                  :config="config"
                  class="input is-black"
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              label.label Precio U.
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='0.00',
                  v-model="articulo.precioUnitario",
                  :disabled="isDisabled"
                )
          .column.is-2
            .field
              input#checkGarantia.is-checkradio.is-circle(type='checkbox' name='checkPrioridad' v-model="articulo.garantia" :disabled="isDisabled")
              label.is-size-6(for='checkGarantia') Garantía
          .column.is-3.is-offset-1(v-show="articulo.garantia")
            .field
              label.label Término Garantía
              .control
                flat-pickr(
                  v-model='articulo.finishGarantia'
                  :config="config"
                  class="input is-black"
                  :disabled="isDisabled"
                )
        .columns
          .column.is-3
            .field
              label.label idSAP
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='idSAP',
                  v-model="articulo.idSAP",
                  :disabled="isDisabled"
                )
          .column.is-3
            .field
              label.label Estado
              .control.has-icons-left
                .select.is-black.is-rounded
                  select(v-model="articulo.estado" disabled)
                    option(value="" checked) Seleccione una estado 
                    option(value='0' checked='') NUEVO
                    option(value='1') USADO
                    option(value='7') PRUEBAS
                    option(value='8') INSTALADO
                    option(value='9') REPARACIÓN
                    option(value='10') DESECHADO
                .icon.is-small.is-left
                  i.fas.fa-box-open
          .column.is-6
            .field
              label.label Observaciones
              .control
                input.input.is-black(
                  type='text', 
                  placeholder='Observaciones',
                  v-model="articulo.observaciones",
                  :disabled="isDisabled"
                )
        .columns
          .column.is-12
            a.button.is-warning.is-rounded.is-medium(@click="editItem" v-show="!isEditing") Editar
            | &nbsp
            a.button.is-success.is-rounded.is-medium(@click="updateItem" v-show="isEditing") Actualizar
            | &nbsp
            a.button.is-default.is-rounded.is-medium(@click="cancelEditItem" v-show="isEditing") Cancelar
</template>

<script>
import Loader from '../shared/Loader.vue'
import HeaderInventario from './layout/HeaderInventario.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'
import { mapState } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { Spanish } from "flatpickr/dist/l10n/es.js"
import moment from 'moment'

export default {
  name: 'ArticuloDetalle',
  components: { Loader, NavBarInventario, HeaderInventario, Typeahead, flatPickr },
  data () {
    return {
      isDisabled: true,
      isDisabledEspecial: true,
      isEditing: false,
      isSaved: false,
      isLoading: true,
      tipos: [],
      articulo: {
        id: '',
        serie: '',
        marca: '',
        modelo: '',
        observaciones: '',
        categoria: '',
        subcategoria: '',
        tag: '',
        direccionIP: '',
        macAddressW: '',
        macAddressE: '',
        fechaReg: '',
        ubicacion: '',
        oficina: '',
        ordenCompra: '',
        fechaCompra: '',
        garantia: '',
        finishGarantia: '',
        idIngresa: '',
        ingresa: '',
        idResguardo: '',
        resguardo: '',
        estado: '',
        idSAP: '',
        precioUnitario: '',
        placas: '',
        localizacion: 0,
        partida: '',
        noParte: '',
      },
      isTipoTel: false,
      isTipoTarjeta: false,
      isTipoVehiculo: false,
      OldArticulo: {},
      itemSel: {},
      itemData: {},
      idArticulo: '',
      oficinas: [],
      oficinasSel: [],
      config: {
        wrap: false, // set wrap to true only when using 'input-group'
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: Spanish, // locale for this instance only
      },
      cambios: [],
      isDisabledVehiculo: true,
      isDisabledTarjeta: true,
      isEditingPlacas: false,
      automoviles: [],
      automovilSel: {},
      isEditingAuto: false,
      localizaciones: [],
      localizacionesFilter: [],
    }
  },
  watch: {
    'articulo.ubicacion'() {
      this.oficinasSel = this.oficinas.filter( ofi => ofi.source === this.articulo.ubicacion )
    },
    itemSel () {
      this.articulo.id_cat = this.itemSel.id_cat
      this.articulo.categoria = this.itemSel.categoria
      this.articulo.id_subcat = this.itemSel.id_subcat
      this.articulo.subcategoria = this.itemSel.subcategoria
      this.articulo.id_artBase = this.itemSel.id
    }
  },
  methods: {
    obtenerTipos () {
      InventarioServices.getBaseArticulos()
        .then(res => {
          this.tipos = res.map(this.convetirArtBase)
          this.obtenerLocalizaciones()
          this.deshabilitarTypeahead()
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'Ok')
        })
    },

    convetirArtBase(art) {
      const subcat = art.subcategoria === '' ? '' : ` - ${art.subcategoria}`
      const model = art.modelo === '' ? '' : ` - ${art.modelo}`
      const marc = art.marca === '' ? '' : ` | ${art.marca}`
      const texto = `${art.categoria}${subcat}${marc}${model}`
      return {
        ...art,
        id: parseInt(art.id),
        text: texto
      }
    },
    
    obtenerDataProducto() {
      this.idArticulo = this.$route.params.id
      InventarioServices.getArticulosInd(this.idArticulo)
        .then(res => {
          const dataArt = this.convertirArticulo(res[0])
          console.log(dataArt)
          this.articulo.id = dataArt.id
          this.articulo.serie = dataArt.serie
          this.articulo.marca = dataArt.marca
          this.articulo.modelo = dataArt.modelo
          this.articulo.observaciones = dataArt.observaciones
          this.articulo.id_cat = dataArt.id_cat
          this.articulo.categoria = dataArt.categoria
          this.articulo.id_subcat = dataArt.id_subcat
          this.articulo.subcategoria = dataArt.subcategoria
          this.articulo.id_artBase = dataArt.id_artBase
          this.articulo.tag = dataArt.tag
          this.articulo.direccionIP = dataArt.direccionIP
          this.articulo.macAddressW = dataArt.macAddressW
          this.articulo.macAddressE = dataArt.macAddressE
          this.articulo.fechaReg = dataArt.fechaReg
          this.articulo.ubicacion = dataArt.ubicacion === 'CORPORATIVO' ? 'CORPO' : dataArt.ubicacion
          const ofiSel = this.oficinas.find( ofi => ofi.clave === dataArt.oficina )
          this.articulo.oficina = ofiSel.clave
          this.articulo.ordenCompra = dataArt.ordenCompra
          this.articulo.fechaCompra = dataArt.fechaCompra
          this.articulo.finishGarantia = dataArt.terminoGarantia
          this.articulo.idIngresa = dataArt.idIngresa
          this.articulo.ingresa = dataArt.ingresa
          this.articulo.idResguardo = dataArt.idResguardo
          this.articulo.resguardo = dataArt.resguardo
          this.articulo.estado = dataArt.estado
          this.articulo.ultimoMov = dataArt.ultimoMov
          this.articulo.precioUnitario = dataArt.precioUnitario
          this.articulo.idSAP = dataArt.idSAP == 0 ? '' : dataArt.idSAP
          this.articulo.numeroTelefono = dataArt.numeroTelefono
          this.articulo.tipoAdm = dataArt.tipoAdm
          this.articulo.placas = dataArt.placas
          this.isLoading = false
          this.isTipoTel = dataArt.tipoAdm == 2
          this.isTipoTarjeta = dataArt.tipoAdm == 6
          this.isTipoVehiculo = dataArt.tipoAdm == 1
          if (dataArt.garantia === '0') {
            this.articulo.garantia = false
          } else {
            this.articulo.garantia = true
          }
          this.articulo.vehiculo = parseInt(dataArt.vehiculo)
          this.articulo.partida = dataArt.partida
          this.articulo.noParte = dataArt.noParte
          this.localizacionesFilter = this.localizaciones.filter( loc => loc.id_oficina == ofiSel.id)
          console.log(dataArt.localizacion)
          if (dataArt.id_localizacion > 0) {
            const localizacionSel = this.localizaciones.find( loc => loc.id == dataArt.id_localizacion)
            this.articulo.localizacion = localizacionSel.id
          }
          this.OldArticulo = Object.assign({}, this.articulo)
          
          this.itemData = this.tipos.find( art => art.id == this.articulo.id_artBase)
          this.itemSel = this.itemData
          
          if (dataArt.tipoAdm == 6) {
            this.obtenerAutos()
          }
          this.isLoading = false

          
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'Ok')
        })
      
      
    },

    convertirArticulo(art) {
      return {
        ...art,
        estado: parseInt(art.estado),
        id_artBase: parseInt(art.id_artBase),
        tipoAdm: parseInt(art.tipoAdm),
        idSAP: art.idSAP ? parseInt(art.idSAP) : '',
        localizacion: art.id_localizacion ? parseInt(art.id_localizacion) : 0,
      }
    },

    editItem () {
      this.isEditing = true
      this.isDisabled = false
      if (this.isArticuloEspecial) {
        this.isDisabledEspecial = false
      }
      this.habilitarTypeahead()
    },

    cancelEditItem () {
      this.isEditing = false
      this.isDisabled = true
      if (this.isArticuloEspecial) {
        this.isDisabledEspecial = true
      }
      this.deshabilitarTypeahead()
    },

    updateItem () {
      this.isLoading = true
      let garantiaInt
      let fechaFinGarantia = ''
      if (this.articulo.garantia) {
        garantiaInt = 1
        fechaFinGarantia = this.articulo.finishGarantia
      } else {
        garantiaInt = 0
        fechaFinGarantia = null
      }
      this.cambios = []
      Object.entries(this.articulo).forEach(([key, value]) => {
        if (value !== this.OldArticulo[key]) {
          this.cambios.push(`Modificó: ${this.OldArticulo[key]} a ${value}`)
        }
      })
      console.log(this.cambios)
      let texto = ''
      this.cambios.map( (c, index) => {
        texto += `${c}${index + 1 < this.cambios.length ? ', ' : ''}`
      })
      this.isLoading = false
      const idSap = this.articulo.idSAP == '' ? 0 : this.articulo.idSAP
      if (!this.isArticuloEspecial) {

        InventarioServices.updateArticulo(this.articulo.id, this.articulo.serie, this.articulo.marca, 
        this.articulo.modelo, this.articulo.observaciones, this.itemSel.id_cat, this.itemSel.categoria,
        this.itemSel.id_subcat,this.itemSel.subcategoria, this.itemSel.id, this.articulo.tag, 
        this.articulo.direccionIP, this.articulo.macAddressW, this.articulo.macAddressE, 
        this.articulo.ordenCompra, this.articulo.fechaCompra, fechaFinGarantia, garantiaInt, 
        this.articulo.precioUnitario === '' ? '0': this.articulo.precioUnitario, idSap,
        this.articulo.numeroTelefono, this.articulo.partida, this.articulo.noParte, this.articulo.localizacion)
          .then((res) => {
            this.displayToast(res.success ? 'toasted-primary' : 'bubble', res.respuesta, res.success ? 'done' : 'ban', 'OK')
            if (res.success) {
              if (this.cambios.length > 0) {
                const fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
                InventarioServices.updateCambios(this.userLogin.id, this.articulo.id, fechaReg, texto)
                  .then( data => {
                    console.log(data)
                  })
                  .catch(e => {
                    console.log(e.message)
                  })
              } 
              this.backPage()
            }
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'Ok')
          })
      } else {
        InventarioServices.updateMaquinaria(this.articulo.id, this.articulo.serie, this.articulo.marca, 
        this.articulo.modelo, this.articulo.observaciones, this.itemSel.id_cat, this.itemSel.categoria,
        this.itemSel.id_subcat,this.itemSel.subcategoria, this.itemSel.id, this.articulo.tag, 
        this.articulo.direccionIP, this.articulo.macAddressW, this.articulo.macAddressE, 
        this.articulo.ordenCompra, this.articulo.fechaCompra, fechaFinGarantia, garantiaInt, 
        this.articulo.precioUnitario, idSap, this.articulo.ubicacion, this.articulo.oficina)
          .then((res) => {
            this.displayToast(res.success ? 'toasted-primary' : 'bubble', res.respuesta, res.success ? 'done' : 'ban', 'Ok,')
            if (res.success) {
              if (this.cambios.length > 0) {
                const fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
                InventarioServices.updateCambios(this.userLogin.id, this.articulo.id, fechaReg, texto)
                  .then( data => {
                    console.log(data)
                  })
                  .catch(e => {
                    console.log(e.message)
                  })
              } 
              this.backPage()
            }
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'Ok')
          })
      }
      
      this.deshabilitarTypeahead()
    },

    deshabilitarTypeahead () {
      let typeahead = document.getElementById('type_itemsTipo')
      let typeaheadHTML = Array.from(typeahead.children[0].children)
      typeaheadHTML[0].setAttribute('disabled', 'disabled')
    },

    habilitarTypeahead () {
      let typeahead = document.getElementById('type_itemsTipo')
      let typeaheadHTML = Array.from(typeahead.children[0].children)
      typeaheadHTML[0].removeAttribute('disabled')
    },

    backPage () {
      this.$router.back()
    },

    displayToast(tema, text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: tema, 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },

    editarPlacas() {
      this.isDisabledVehiculo = false 
      this.isEditingPlacas = true
    },

    cancelarEditarPlacas() {
      this.isEditingPlacas = false
      this.isDisabledVehiculo = true
    },

    actualizarPlacas() {
      this.isLoading = true
      InventarioServices.editarPlacas(this.articulo.id, this.articulo.placas)
        .then((res) => {
            this.displayToast(res.success ? 'toasted-primary' : 'bubble', res.respuesta, res.success ? 'done' : 'ban', 'Ok,')
            if (res.success) {
              const texto = `Modificó las placas ${this.OldArticulo.placas} a ${this.articulo.placas}`
              const fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
              InventarioServices.updateCambios(this.userLogin.id, this.articulo.id, fechaReg, texto)
                .then( data => {
                  console.log(data)
                })
                .catch(e => {
                  console.log(e.message)
                })
              this.cancelarEditarPlacas()
            }
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'Ok')
          })
      
    },

    obtenerOficinas() {
      InventarioServices.getOficinas()
        .then( data => {
          this.oficinas = data.map(this.convertirOficinas)
          this.obtenerTipos()
        })
        .catch((e) => {
          this.isLoading = false
          consoe.log(`Error: ${e.message}`)
        })
    },

    convertirOficinas(ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        oficina: ofi.nombre,
        id_ubicacion: parseInt(ofi.id_ubicacion),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },

    obtenerAutos () {
      InventarioServices.getAutomoviles(this.articulo.idResguardo)
        .then( data => {
          this.automoviles = data.map(this.convertirAutos)
          this.automovilSel = this.automoviles.find( a => a.id_vehiculo == this.articulo.vehiculo)
        })
        .catch((e) => {
          this.isLoading = false
          consoe.log(`Error: ${e.message}`)
        })
    },

    convertirAutos (auto) {
      return {
        ...auto,
        estado: parseInt(auto.estado),
        garantia: parseInt(auto.garantia),
        id_vehiculo: parseInt(auto.id_vehiculo),
      }
    },

    editarAuto () {
      this.isDisabledTarjeta = false 
      this.isEditingAuto = true
    },

    cancelarEditarAuto () {
      this.isDisabledTarjeta = true
      this.isEditingAuto = false
    },

    actualizarAuto () {
      InventarioServices.actualizarAutoEnTarjeta(this.articulo.id, this.automovilSel.id_vehiculo)
        .then( res => {
          this.displayToast(res.success ? 'toasted-primary' : 'bubble', res.respuesta, res.success ? 'done' : 'ban', 'Ok,')
          this.cancelarEditarAuto()
        })
        .catch((e) => {
          this.isLoading = false
          consoe.log(`Error: ${e.message}`)
        })
      
    },

    obtenerLocalizaciones() {
      InventarioServices.getLocalizaciones()
        .then( data => {
          this.localizaciones = data.map(this.convertirLocalizaciones)
          this.obtenerDataProducto()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirLocalizaciones(loc) {
      return {
        ...loc,
        id: parseInt(loc.id),
        id_oficina: parseInt(loc.id_oficina),
      }
    },
  },
  created () {
    this.obtenerOficinas()

  },
  computed: {
    ...mapState(['userLogin', 'isArticuloEspecial'])
  }  
}
</script>

<style lang="css" scoped>
  #checkGarantia {
    display: flex;
    align-items: center;
  }
  .is-button-bottom {
    margin-top: 35px;
  }
</style>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/ArticuloDetalle.vue